"use client";
import { jsx as i, jsxs as r } from "react/jsx-runtime";
import e from "clsx";
import { memo as a } from "react";
import { Box as l } from "../base/Base.js";
import '../../assets/ListBlock.css';const y = "_block_nir0y_1", w = "_classic_nir0y_5", g = "_item_w_icon_nir0y_9", N = "_item_w_title_nir0y_9", h = "_bordered_nir0y_17", p = "_clear_nir0y_23", k = "_icon_nir0y_32", L = "_fit_nir0y_35", b = "_dotsList_nir0y_40", x = "_text_nir0y_69", I = "_white_nir0y_73", B = "_violet_nir0y_78", f = "_orange_nir0y_83", v = "_gray_nir0y_88", W = "_red_nir0y_93", T = "_notice_nir0y_98", j = "_title_nir0y_107", u = "_big_nir0y_112", A = "_gradient_nir0y_146", t = {
  block: y,
  classic: w,
  item_w_icon: g,
  item_w_title: N,
  bordered: h,
  clear: p,
  icon: k,
  fit: L,
  dotsList: b,
  text: x,
  white: I,
  violet: B,
  orange: f,
  gray: v,
  red: W,
  notice: T,
  title: j,
  big: u,
  gradient: A
}, q = a(
  ({ theme: c = "classic", fit: s, dotsList: n, children: o, ..._ }) => /* @__PURE__ */ i(
    l,
    {
      className: e(t.block, t[c], {
        [t.fit]: s,
        [t.dotsList]: n
      }),
      ..._,
      children: o
    }
  )
);
q.displayName = "ListBlock";
const z = a(
  ({ icon: c, iconColor: s = "gray", text: n, textColor: o = "white", gap: _ = 16 }) => /* @__PURE__ */ r(l, { row: !0, gap: _, className: t.item_w_icon, children: [
    /* @__PURE__ */ i(
      "div",
      {
        className: e("material-icons", t.icon, t[s]),
        "data-icon": c
      }
    ),
    /* @__PURE__ */ i("span", { className: e(t.text, t[o]), children: n })
  ] })
);
z.displayName = "ListBlockItemWIcon";
const C = a(
  ({ title: c, titleColor: s = "violet", text: n, textColor: o = "white", gap: _ = 16 }) => /* @__PURE__ */ r(l, { gap: _, className: t.item_w_title, children: [
    /* @__PURE__ */ i("span", { className: e(t.title, t.big, t[s]), children: c }),
    /* @__PURE__ */ i("span", { className: e(t.text, t[o]), children: n })
  ] })
);
C.displayName = "ListBlockItemWTitle";
const D = a(
  ({
    icon: c,
    iconColor: s = "gray",
    title: n,
    titleColor: o = "violet",
    text: _,
    textColor: m = "white",
    gap: d = 16
  }) => /* @__PURE__ */ r(l, { row: !0, gap: d, className: t.item_w_icon, children: [
    /* @__PURE__ */ i(
      "div",
      {
        className: e("material-icons", t.icon, t[s]),
        "data-icon": c
      }
    ),
    /* @__PURE__ */ r(l, { gap: 8, className: t.item_w_title, children: [
      /* @__PURE__ */ i("span", { className: e(t.title, t[o]), children: n }),
      /* @__PURE__ */ i("span", { className: e(t.text, t[m]), children: _ })
    ] })
  ] })
);
D.displayName = "ListBlockItemWTitleAndIcon";
export {
  q as ListBlock,
  z as ListBlockItemWIcon,
  C as ListBlockItemWTitle,
  D as ListBlockItemWTitleAndIcon
};
